import {Component} from '@angular/core';

@Component({
  selector: 'app-client-icon',
  templateUrl: './client-icon.component.html'
})
export class ClientIconComponent {
}
